/**
 * The words of the duplicate-login warning and of the kicked client's notice
 * (`q-duplicate-login-warning`). Kept out of the components so they are tested headless.
 */

import {
  KICK_REASON_LOGGED_IN_ELSEWHERE,
  KICK_REASON_SESSION_TAKEN_OVER,
} from '@great-cloud/shared/client';

export interface DuplicateLoginCopy {
  title: string;
  body: string;
  note: string | null;
  backOut: string;
  takeOver: string;
  takingOver: string;
}

export function duplicateLoginCopy(rateLimited: boolean): DuplicateLoginCopy {
  return {
    title: 'You’re already logged in on another device',
    body:
      'This account is playing on another device right now. You can stay logged in there, ' +
      'or end that session and play here instead.',
    note: rateLimited
      ? 'That account changed devices a moment ago. Wait a few seconds, then try again.'
      : null,
    backOut: 'Back out — stay logged in on the other device',
    takeOver: 'End the other session and play here',
    takingOver: 'Ending the other session…',
  };
}

/** Where a kicked client goes and what it is told; null = not a duplicate-login kick. */
export interface KickedRoute {
  notice: string;
  /** The login itself was ended (revoked by the server): forget the stored token. */
  clearToken: boolean;
}

export function kickedRoute(reason: string): KickedRoute | null {
  if (reason === KICK_REASON_SESSION_TAKEN_OVER) {
    return {
      notice: 'You were logged in from another device. Log in again to play here.',
      clearToken: true,
    };
  }
  if (reason === KICK_REASON_LOGGED_IN_ELSEWHERE) {
    // Same login (another tab or window of this browser): the token is still valid and shared.
    return {
      notice: 'This account was opened in another window or tab.',
      clearToken: false,
    };
  }
  return null;
}
